// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-columns[data-v-550e2b59]{\n    -moz-column-count: 3;\n         column-count: 3;\n    /* height: 50vh; */\n}\n.disable-selector[data-v-550e2b59]{\n    color:rgba(225,225,225);\n}\n@media (max-width: 1440px){\n.singular-main .spainhn-subtitle-2[data-v-550e2b59]{\n        font-size: 24px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
